"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgSkeletonLineChart(props) {
    return (React.createElement("svg", __assign({ id: "skeleton-line-chart_svg__Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "100%", height: "100%", x: 0, y: 0, viewBox: "0 0 392 82", xmlSpace: "preserve" }, props),
        React.createElement("style", null, '.skeleton-line-chart_svg__st1{fill:#848484}'),
        React.createElement("defs", null,
            React.createElement("path", { id: "skeleton-line-chart_svg__SVGID_1_", d: "M0 0h1v81H0z" })),
        React.createElement("use", { xlinkHref: "#skeleton-line-chart_svg__SVGID_1_", overflow: "visible", fill: "#848484" }),
        React.createElement("clipPath", { id: "skeleton-line-chart_svg__SVGID_2_" },
            React.createElement("use", { xlinkHref: "#skeleton-line-chart_svg__SVGID_1_", overflow: "visible" })),
        React.createElement("path", { opacity: 0.1, clipPath: "url(#skeleton-line-chart_svg__SVGID_2_)", fill: "#848484", d: "M-1-1h3v83h-3z" }),
        React.createElement("path", { className: "skeleton-line-chart_svg__st1", d: "M0 81h392v1H0z" }),
        React.createElement("path", { className: "skeleton-line-chart_svg__st1", d: "M121.7 82L93.4 10.3l-30.7 6.3L35.5 53 .5 13.9l.8-.6 34.1 38.2 26.7-35.8h.2l31.8-6.6 28 70.9 32.6-38.4L192.9-.8l30.6 47 48.2-28 .2.2 50 41.8 69.9-13.8.2 1-70.4 13.9-.2-.1-49.9-41.8-48.3 28.2L192.8.8l-37.4 41.5z" })));
}
exports.default = SvgSkeletonLineChart;
//# sourceMappingURL=SkeletonLineChart.js.map